import React, { useState } from 'react'
import contactImage from '../../../assets/img/contact.svg'
import CTA from '../../../components/CTA'
import { contactItems } from '../contactItems'

const ContactMobile: React.FC = () => {
	const [copiedIndex, setCopiedIndex] = useState<number | null>(null)

	const handleCopyToClipboard = (email: string, index: number) => {
		navigator.clipboard.writeText(email).then(() => {
			setCopiedIndex(index)

			// Reset the copied state after 2 seconds
			setTimeout(() => {
				setCopiedIndex(null)
			}, 2000)
		}).catch(err => {
			console.error('Failed to copy: ', err)
		})
	}

	const handleEmailClick = (email: string) => {
		window.location.href = `mailto:${email}`
	}

  return (
    <section className="w-full flex pt-[120px] justify-center relative overflow-visible">
      {/* Contact Image */}
      <div className="absolute max-w-[560px] bottom-[-5%] p-5 h-auto z-40 opacity-100">
        <img 
          src={contactImage} 
          alt="Contact illustration" 
          className="w-full h-full object-contain"
        />
      </div>

      {/* Contact Content */}
      <div className="w-[560px] flex flex-col items-center relative pl-5 pr-5">
        <h1 className="font-apropal text-[48px] text-black font-bold mb-4 text-left w-full">
          Kontakt
        </h1>
        
        <p className="text-[16px] mb-8 text-left w-full">
          Wszystkie treści tworzę samodzielnie. 
          <br />
          Jeśli chcesz pomóc mi działać dalej - wesprzyj mnie na buycoffee! 
          <br />
          <br />
          A jeśli chcesz po prostu pogadać - też super, lubię gadać!
        </p>
        
        <div className="flex w-full space-y-2 flex-col mb-[95vw]">
          {contactItems.map((item, index) => (
            <div 
              key={index} 
              className="w-full bg-white border rounded-lg p-3 text-center shadow-md w-64 flex flex-col items-center"
            >
              <div 
                className={`flex justify-center mb-4 ${item.email ? 'cursor-pointer' : ''}`}
                onClick={() => item.email && handleCopyToClipboard(item.email, index)}
              >
                <img 
                  src={item.icon} 
                  alt={`${item.description} icon`} 
                  className="w-52 h-20"
                />
              </div>
              {copiedIndex === index ? (
                <p className="text-green-600 text-[13px] mb-2">Skopiowano!</p>
              ) : (
                <CTA 
                  text={item.description}
                  backgroundColor="bg-black"
                  fontColor="text-white"
                  fontSize="text-[15px]"
                  onClick={item.email ? () => handleEmailClick(item.email as string) : undefined}
                  link={item.link}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default ContactMobile